import {CoinsHistoryTransaction} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coins_history_transaction.types';
import {useHistory} from '@aboutyou/router';
import {COLORS, GenericIconName, Icon, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {TransactionEventList} from '../shared/TransactionEventList';

export const Transaction: React.FC<{
  className?: string;
  transaction: CoinsHistoryTransaction;
}> = ({className, transaction}) => {
  const history = useHistory();

  const onClick = () => {
    if (transaction.link) {
      history.push(transaction.link.url);
    }
  };

  return (
    <TransactionWrapper
      className={className}
      onClick={onClick}
      data-cursor-pointer={!!transaction.link?.url}
      data-testid={
        transaction.link?.url
          ? 'coinsHistoryTransactionOrder'
          : 'coinsHistoryTransaction'
      }
    >
      <TransactionHeaderWrapper>
        <TransactionSource
          showArrow={!!transaction.link?.url}
          source={transaction.source}
        />
        <Text size="px10" color="Grey0">
          {transaction.date}
        </Text>
      </TransactionHeaderWrapper>
      <TransactionEventList events={transaction.events} />
    </TransactionWrapper>
  );
};

const TransactionSource: React.FC<{source: string; showArrow: boolean}> = ({
  source,
  showArrow,
}) => {
  return (
    <TransactionSourceWrapper>
      <Text
        size="px10"
        color="Grey0"
        transform="uppercase"
        weight="mediumHeavy"
      >
        {source}
      </Text>
      {showArrow && (
        <TransactionIcon
          asset={GenericIconName.ArrowRight}
          size="XS"
          fill={COLORS['Fill.Grey.Secondary']}
        />
      )}
    </TransactionSourceWrapper>
  );
};

const TransactionIcon = styled(Icon)`
  && {
    width: 11px;
    height: 11px;
    flex-basis: 11px;
  }
`;

const TransactionSourceWrapper = styled(Text)`
  display: flex;
  align-items: center;
  gap: 0.125rem;
`;

const TransactionHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  line-height: 1.5;
`;

const TransactionWrapper = styled.div`
  width: 100%;

  &[data-cursor-pointer='true'] {
    cursor: pointer;
  }
`;
